export const EVENT = "event";
export const SESSION = "session";
export const MEMBER = "member";
export const GROUP = "group";
export const CURRENT_GROUP_MEMBERS = "current_group_members";
